import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, empty, ofArray, tail, head, isEmpty } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(0, [])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "passwordlost") ? (isEmpty(tail(_arg_3)) ? (new Page(0, [])) : undefined) : ((head(_arg_3) === "passwordreset") ? (!isEmpty(tail(_arg_3)) ? (isEmpty(tail(tail(_arg_3))) ? (new Page(1, [head(tail(_arg_3))])) : undefined) : undefined) : undefined)) : undefined), (_arg_2) => {
    switch (_arg_2.tag) {
        case 1:
            return ofArray(["passwordreset", _arg_2.fields[0]]);
        case 2:
            return empty();
        default:
            return singleton("passwordlost");
    }
}, (_arg) => {
    if (_arg.tag === 8) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
